import _ from 'lodash'
import type { Experiments } from '@wix/thunderbolt-symbols'
import { isExperimentOpen } from '@wix/thunderbolt-commons'
import type { IUnfinishedTasks, IViewerHandlers } from './types'

export const UnfinishedTasks = (
	{ viewerHandlers }: IViewerHandlers,
	experiments: Experiments = {}
): IUnfinishedTasks => {
	const isThunderboltRenderer = process.env.PACKAGE_NAME === 'thunderbolt-renderer'
	const reportWorkerUnfinishedTasks = isExperimentOpen(
		'specs.thunderbolt.reportWorkerUnfinishedTasksOnPageInitTimeout',
		experiments
	)

	return {
		add: (name) => {
			if (isThunderboltRenderer) {
				return _.noop
			}
			if (process.env.browser && !reportWorkerUnfinishedTasks) {
				return _.noop
			}
			const id = _.uniqueId()
			viewerHandlers.unfinishedTasks.add(id, name)

			return () => {
				viewerHandlers.unfinishedTasks.remove(id)
			}
		},
	}
}
